(function($, Drupal) {
  'use strict';
  Drupal.behaviors.doubleSubmit = {
    attach: function(context, settings) {
      $('#bee-add-reservation-form', context).once('doubleSubmit').on('submit', function() {
        $(this).find(':input[type=submit]').prop('disabled', true);
      });
    }
  };
})(jQuery, Drupal);
